// Define the initial state
const initialState = {
  selectedCategory: "Bootcamps", // Initial state is "Bootcamps"
};

// Create the reducer function
const programCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CATEGORY":
      return {
        ...state,
        selectedCategory: action.payload,
      };
    default:
      return state;
  }
};

export default programCategoryReducer;
